@if (advertiser) {
  <div class="flex-row gap-16">
    <div class="avatar-container">
      <div class="avatar">
        <lib-photo [url]="advertiser.photoThumb" [width]="'100px'" [radius]="'50%'"></lib-photo>
      </div>
    </div>
    <div class="flex-column gap-16">
      <div class="account-name">
        <label class="label">Advertiser name</label>
        <div>
          @if (!isFullScreen) {
            <a mat-button color="accent" matTooltip="Open full details page" href="advertisers/{{advertiser.id}}"><b>{{ advertiser.name }}</b></a>
          }
          @if (isFullScreen) {
            <span><strong>{{ advertiser.name }}</strong></span>
          }
        </div>
      </div>
      <div class="account-name">
        <label class="label">Description</label>
        <div>
          @if (isFullScreen) {
            <span>{{ advertiser.description }} </span>
          }
        </div>
      </div>
    </div>
  </div>
}
